import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React from 'react';
import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import style from './style.module.less';
import classnames from 'classnames';

export const MissingLabelProvider = () => {
  return (
    <div className={classnames(style['planning-rate-card'], style['no-provider'])}>
      <Text className={style['no-provider-text']} textType={TextType.Caption} value={messages.noLabelProviderOnShipmentMessage} />
      <FontAwesomeIcon className={style['shipment-actions-disabled']} icon={faEllipsisH} />
    </div>
  );
};
